<section class="sd-filter" v-if="filterCopy">
    <section class="sd-filter__element" v-for="(filter, index) in filterCopy.filterElements">
        <section class="sd-filter__input" v-if="filter.type === filterTypes.enum.INPUT" >
            <div class="sd-input">
                <i v-if="filter.icon" class="far sd-input__icon" :class="filter.icon"></i>
                <input class="sd-input__element p-l-16" :class="{'p-l-32': filter.icon}" :placeholder="$t(filter.label)" @input="emitUpdate" v-model="filter.filterString" :required="false"/>
            </div>
        </section>
    </section>
</section>